import classNames from 'classnames';
import React from 'react';

interface SwiperSlideProps {
  /** Headline of the SwiperSlide. */
  caption?: React.ReactNode;
  /** Content of the SwiperSlide. */
  children: React.ReactNode;
  /** CSS class name. */
  className?: string;
}

/** Displays a Slide in the format fit to be displayed in a Swiper. */
const SwiperSlide = ({ caption, children, className }: SwiperSlideProps) => {
  return (
    <div className={classNames(className, 'ce-swiper-slide')}>
      {children}
      {caption && <h2>{caption}</h2>}
    </div>
  );
};

SwiperSlide.defaultProps = {
  caption: null,
  className: null,
};

export default SwiperSlide;
